export default __webpack_public_path__ + "static/media/eye-icon.a15309e4.svg";